import React from "react";
import SimpleChannelTestPage from "./SimpleChannelTestPage";

export const WhatsappTestPage: React.FC = () => (
  <SimpleChannelTestPage channel="whatsapp" />
);

export default WhatsappTestPage;
